<template>
    <div>
      <div class="mt-3 mb-1">
        <v-btn icon :to="{ name: 'diario-escolar', params: { paginaAtualTurmas }}">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </div>

      <v-alert type="error" :value="($v.$invalid && $v.$dirty) || msgArrayError.length > 0" dark class="mb-3">
        <div v-if="$v.$invalid && $v.$dirty"> Preencha os campos corretamente.</div>
        <div v-if="msgArrayError.length > 0">
          <ul v-for="error of msgArrayError" :key="error.key">
            <li>{{ error }}</li>
          </ul>
        </div>
      </v-alert>

      <v-card class="pa-3">
        <form @submit.prevent="onSubmit">
          <TextArea label="Descrição Perfil Turma" rows="10" v-model="form.descricaoperfil" :v="$v.form.descricaoperfil" style="width: 100%"/>
          <div style="text-align: right">
            <v-btn type="submit" :loading="loading" small dark color="teal" class="perfil-turma-btn rounded-sm font-weight-regular">Salvar</v-btn>
          </div>
        </form>
      </v-card>
      <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
      </v-snackbar>
    </div>
</template>

<script>
import store from '@/store/index';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import { required, maxLength, integer } from 'vuelidate/lib/validators';

const DiarioEscolarRepository = RepositoryFactory.get('diarioEscolar');

const dadosUser = () => ({
  ...store.getters.userProfessor,
  ...store.getters.school,
});

export default {
  name: 'PerfilTurma',
  props: {
    ano: [String, Number],
    cdturma: [String, Number],
    disciplina: [String, Number],
    paginaAtualTurmas: [String, Number],
    tipoDeEnsino: [String],
    cdinstruc: [Number],
  },
  data() {
    return {
      msgArrayError: [],
      loading: false,
      snackbar: false,
      submitText: '',
      form: {
        aaletivo: this.ano,
        cdturma: this.cdturma,
        cdinstruc: this.cdinstruc,
        cddiscipl: this.disciplina,
        ...dadosUser(),
        descricaoperfil: '',
      },
    };
  },
  validations: {
    form: {
      aaletivo: { required, integer },
      cdtipesc: { required, integer },
      cdescola: { required, integer },
      cdpessoal: { required, integer },
      cdmatric: { required, integer },
      cddiscipl:  { required, integer },
      cdturma: { required,maxLength: maxLength(4) },
      descricaoperfil: { required },
    }
  },
  async beforeRouteEnter(to, from, next){
    if(typeof to.params.ano === 'undefined' || typeof to.params.cdturma === 'undefined' || typeof to.params.disciplina === 'undefined'){
      return next('/diario-escolar');
    }

    const { data } = await DiarioEscolarRepository.getPerfilTurma({
      ...dadosUser(),
      aaletivo: to.params.ano,
      cdturma: to.params.cdturma,
      cddiscipl: to.params.disciplina,
      cdinstruc: to.params.cdinstruc,
    });

    next(vm => vm.load(data.results));
  },
  methods: {
    load(dadosPerfilTurma){
      this.form.descricaoperfil = (dadosPerfilTurma) ? dadosPerfilTurma.descricaoperfil : '';
      this.$Progress.finish();
    },
    async onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) { return; }

      try {
        this.loading = true;
        const { data } = await DiarioEscolarRepository.postPerfilTurma(this.form);

        this.submitText = data.message;
        this.snackbar = true;
        this.msgArrayError = [];

        this.$router.push({ path: '/diario-escolar' });
      } catch(error) {
        if (error.response.data.status == 'ERROR_BUSINESS_RULE') { this.msgArrayError = error.response.data.errorMessage; }
      }
      this.loading = false;
    },
  },
}
</script>

<style lang="scss">
.aulas-title{
  font-size: 16px;
}

.perfil-turma-btn {
  margin-right: 0;
  margin-top: 15px;
}
</style>
